import type { Element } from "slate";
import {
  Editor,
  Node,
  normalizeNode,
  Path,
  Point,
  Range,
  Transforms,
} from "slate";

import { Helpers } from "../helpers";
import { NodeTypes } from "../slateTypes";

export const withInline = (editor: Editor) => {
  const { insertData, insertText, isInline, insertBreak } = editor;
  editor.isInline = (element: Element) =>
    element.type === "link" || isInline(element);

  editor.insertBreak = () => {
    const link = Helpers.isElement(editor, NodeTypes.LINK);
    const { selection } = editor;
    if (link && selection) {
      insertBreak();
      Transforms.unwrapNodes(editor, {
        match: (n: any) => n.type === "link" && n.children[0].text.length === 0,
        split: true,
      });
    } else {
      insertBreak();
    }
  };

  editor.insertText = (text: string) => {
    const { selection } = editor;
    if (selection) {
      const isCollapsed = selection && Range.isCollapsed(selection);
      const link = Helpers.isElement(editor, NodeTypes.LINK);
      if (link) {
        if (isCollapsed) {
          const point = Editor.end(editor, selection.anchor.path.slice(0, -1));
          const isLastChar = Point.compare(point, selection.focus) === 0;
          if (isLastChar) {
            const marks: any = Editor.marks(editor);
            Transforms.insertNodes(
              editor,
              { type: "text", text, ...marks },
              {
                match: (n: any) => n.type === "link",
              },
            );
          } else {
            insertText(text);
          }
        }
        return;
      }
      insertText(text);
    }
  };

  editor.insertData = data => {
    const text = data.getData("text/plain");

    if (text && Helpers.isUrl(text)) {
      Helpers.wrapLink(editor, text);
    } else {
      insertData(data);
    }
  };

  return editor;
};
